import { CSSObject } from '@chakra-ui/react';

export const FlexResponsibleGamblingSlideContainer: CSSObject = {
  textAlign: 'center',
};

export const TextResponsibleGamblingHeading = (): CSSObject => ({
  px: '10',
});
